import {
  EXPLAIN_LEVEL_SELECTION_IMPACT,
  WELCOME_TO_MEMRISE_STORAGE_KEY,
  MIGRATED_TO_MY_PROGRESS_STORAGE_KEY,
  PRE_RELEASE_USERS_SEEN_MY_ACTIVITIES_STORAGE_KEY,
  STAGE_UP_POINTS_STORAGE_KEY,
  HAS_SEEN_2025_ONBOARDING_STORAGE_KEY,
  HAS_SEEN_SOFT_SELL_STORAGE_KEY,
  AUTO_SUBSCRIBE_AFTER_RELOAD_STORAGE_KEY,
} from 'src/constants/storageKeys.const';
import { forEachKeyInLocalStorage, forEachKeyInSessionStorage } from 'src/utils/webStorageUtils';

const preservedLocalStorageKeys = [
  WELCOME_TO_MEMRISE_STORAGE_KEY,
  EXPLAIN_LEVEL_SELECTION_IMPACT,
  MIGRATED_TO_MY_PROGRESS_STORAGE_KEY,
  PRE_RELEASE_USERS_SEEN_MY_ACTIVITIES_STORAGE_KEY,
  STAGE_UP_POINTS_STORAGE_KEY,
  HAS_SEEN_2025_ONBOARDING_STORAGE_KEY,
  HAS_SEEN_SOFT_SELL_STORAGE_KEY,
  AUTO_SUBSCRIBE_AFTER_RELOAD_STORAGE_KEY,
];

export function cleanupWebStoragesOnLogout() {
  forEachKeyInSessionStorage(key => {
    if (!preservedLocalStorageKeys.includes(key)) {
      sessionStorage.removeItem(key);
    }
  });

  forEachKeyInLocalStorage(key => {
    if (!preservedLocalStorageKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  });
}
